import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContinueAIConversationVariables = Types.Exact<{
  input: Types.ContinueAIConversationInput;
}>;

export type ContinueAIConversation = {
  continueAIConversation: Pick<Types.ContinueAIConversationOutput, 'streamId'>;
};

export const ContinueAIConversationDocument = gql`
  mutation ContinueAIConversation($input: ContinueAIConversationInput!) {
    continueAIConversation(input: $input) {
      streamId
    }
  }
`;
export type ContinueAIConversationMutationFn = Apollo.MutationFunction<
  ContinueAIConversation,
  ContinueAIConversationVariables
>;

/**
 * __useContinueAIConversation__
 *
 * To run a mutation, you first call `useContinueAIConversation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueAIConversation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueAiConversation, { data, loading, error }] = useContinueAIConversation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContinueAIConversation(
  baseOptions?: Apollo.MutationHookOptions<ContinueAIConversation, ContinueAIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ContinueAIConversation, ContinueAIConversationVariables>(
    ContinueAIConversationDocument,
    options,
  );
}
export type ContinueAIConversationHookResult = ReturnType<typeof useContinueAIConversation>;
export type ContinueAIConversationMutationResult = Apollo.MutationResult<ContinueAIConversation>;
export type ContinueAIConversationMutationOptions = Apollo.BaseMutationOptions<
  ContinueAIConversation,
  ContinueAIConversationVariables
>;
export function mockContinueAIConversation({
  data,
  variables,
  errors,
}: {
  data: ContinueAIConversation;
  variables?: ContinueAIConversationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ContinueAIConversationDocument, variables },
    result: { data, errors },
  };
}
